/* eslint-disable @typescript-eslint/no-var-requires */
const marketAvailability = require('../../oneweb.market-availability.js');
const packageMeta = require('./package.json');
const seamlessRc = require('./../../.seamlessrc.json');

const NAME = 'stage-campaign';
const TENANT = seamlessRc.tenantId;
const pluginPath = `/${TENANT}-${NAME}/${TENANT}-${NAME}-${packageMeta.version}`;
const fileName = NAME;

module.exports = {
  manifestVersion: '2.0',
  name: `${TENANT}-${NAME}`,
  version: packageMeta.version,
  config: {
    hasCss: false,
    files: {
      scripts: [
        {
          url: `${pluginPath}/vendors~app.${fileName}.min.js`,
          attrs: {
            type: 'module', // vendor
          },
        },
        {
          url: `${pluginPath}/${fileName}.min.js`,
          attrs: {
            type: 'module', // component
          },
        },
      ],
      styles: [
        {
          url: `${pluginPath}/${TENANT}-${NAME}.css`,
        },
      ],
    },
    dependencies: {
      oneweb: '2.0',
    },
    isUserSessionRequired: false,
    integrationType: 'webcomponent',
    marketAvailability,
  },
  aemComponentConfig: {
    title: 'emh stage-campaign Web Component',
    description: packageMeta.description,
    componentGroup: 'Generic NG - Content',
    productPrefix: seamlessRc.tenantId,
    tagNameWithoutPrefix: 'stage-campaign',
    containerConfig: {
      container: true,
      slots: ['items'],
    },
    dialog: [],
  },
};
